module.exports = __webpack_public_path__ + "img/skip-arrow.029b28ca.svg";